import React, { useEffect } from 'react';

const COUNTRY_OPTIONS = [
  { value: 'All', label: 'Alle Länder' },
  { value: 'United States', label: 'USA' },
  { value: 'Germany', label: 'Deutschland' },
  { value: 'United Kingdom', label: 'Großbritannien' },
  { value: 'Switzerland', label: 'Schweiz' },
  { value: 'France', label: 'Frankreich' },
  { value: 'Netherlands', label: 'Niederlande' },
  { value: 'Sweden', label: 'Schweden' },
  { value: 'Canada', label: 'Kanada' },
  { value: 'China', label: 'China' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Other', label: 'Andere' }
];

const SECTOR_OPTIONS = [
  { value: 'All', label: 'Alle Sektoren' },
  { value: 'Technology', label: 'Technologie' },
  { value: 'Finance', label: 'Finanzen' },
  { value: 'Healthcare', label: 'Gesundheit' },
  { value: 'Energy', label: 'Energie' },
  { value: 'Consumer Cyclical', label: 'Zyklischer Konsum' },
  { value: 'Consumer Defensive', label: 'Defensiver Konsum' },
  { value: 'Industrials', label: 'Industrie' },
  { value: 'Basic Materials', label: 'Grundstoffe' },
  { value: 'Communication Services', label: 'Kommunikation' },
  { value: 'Utilities', label: 'Versorger' },
  { value: 'Real Estate', label: 'Immobilien' }
];

const VALUATION_SLIDERS = [
  { name: 'market_cap', label: 'Marktkapitalisierung', min: 0, max: 3000, step: 10, unit: ' Mrd.', type: 'minimum' },
  { name: 'trailing_p_e', label: 'KGV (Trailing)', min: 0, max: 100, step: 1, unit: '', type: 'maximum' },
  { name: 'forward_p_e', label: 'KGV (Forward)', min: 0, max: 100, step: 1, unit: '', type: 'maximum' },
  { name: 'price_to_book', label: 'Kurs-Buchwert', min: 0, max: 50, step: 0.5, unit: '', type: 'maximum' },
  { name: 'enterprise_to_ebitda', label: 'EV/EBITDA', min: 0, max: 50, step: 0.5, unit: '', type: 'maximum' }
];

const INCOME_SLIDERS = [
  { name: 'dividend', label: 'Dividende', min: 0, max: 20, step: 0.1, unit: ' $', type: 'minimum' },
  { name: 'dividend_yield', label: 'Dividendenrendite', min: 0, max: 15, step: 0.1, unit: '%', type: 'minimum' },
  { name: 'profit_margin', label: 'Gewinnmarge', min: 0, max: 100, step: 1, unit: '%', type: 'minimum' },
  { name: 'operating_margin', label: 'Operative Marge', min: 0, max: 100, step: 1, unit: '%', type: 'minimum' }
];

const GROWTH_SLIDERS = [
  { name: 'next_year_growth', label: 'Wachstum nächstes Jahr', min: 0, max: 100, step: 1, unit: '%', type: 'minimum' },
  { name: 'revenue_growth', label: 'Umsatzwachstum', min: 0, max: 100, step: 1, unit: '%', type: 'minimum' },
  { name: 'earnings_growth', label: 'Gewinnwachstum', min: 0, max: 200, step: 1, unit: '%', type: 'minimum' }
];

const FilterSheet = ({
  isOpen,
  onClose,
  formData,
  onInputChange,
  collapsedSections,
  onToggleSection,
  onReset,
  onApply,
  loading
}) => {

  const renderSlider = (slider) => {
    const config = formData[slider.name];
    const value = config && typeof config === 'object' ? config.value : 0;
    const max = config && typeof config === 'object' ? (config.max || slider.max) : slider.max;
    const percentage = (value / max) * 100;

    return (
      <div className="mobile-slider-group" key={slider.name}>
        <div className="mobile-slider-header">
          <span className="mobile-slider-label">{slider.label}</span>
          <span className="mobile-slider-value">{value}{config ? config.unit : slider.unit}</span>
        </div>
        <div className="mobile-slider-track-container">
          <input
            type="range"
            className="mobile-range-slider"
            name={slider.name}
            id={`slider-${slider.name}`}
            aria-label={`${slider.label} ${config && config.isMax ? 'Maximum' : 'Minimum'}`}
            aria-valuemin={0}
            aria-valuemax={max}
            aria-valuenow={value}
            aria-valuetext={`${value}${config ? config.unit : slider.unit}`}
            min="0"
            max={max}
            step={config && config.unit === '%' ? 1 : (max > 100 ? 10 : 0.5)}
            value={value}
            onChange={onInputChange}
          />
          <div
            className="mobile-slider-fill"
            style={{ width: `${percentage}%` }}
          />
        </div>
        <div className="mobile-slider-limits">
          <span>0{config ? config.unit : slider.unit}</span>
          <span className="mobile-slider-type">
            {config && config.isMax ? 'Maximum' : 'Minimum'}
          </span>
          <span>{max}{config ? config.unit : slider.unit}</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  return (
    <div className={`filter-modal-overlay${isOpen ? ' active' : ''}`} onClick={onClose} aria-hidden={!isOpen}>
      <div className="filter-modal" role="dialog" aria-modal="true" aria-label="Suchfilter" onClick={(e) => e.stopPropagation()}>
        <div className="filter-modal-header">
          <button type="button" className="filter-modal-close" onClick={onClose} aria-label="Filter schließen">
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>
          <h2>Filter</h2>
          <button type="button" className="filter-modal-done" onClick={onApply}>
            Fertig
          </button>
        </div>

        <div className="filter-modal-content">
          <div className="filter-modal-section">
            <div className="filter-modal-row">
              <span className="filter-row-label">Land</span>
              <span className="filter-row-value">
                <select
                  className="filter-select"
                  name="country"
                  aria-label="Land auswählen"
                  value={formData.country || 'All'}
                  onChange={onInputChange}
                >
                  {COUNTRY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="filter-modal-row">
              <span className="filter-row-label">Sektor</span>
              <span className="filter-row-value">
                <select
                  className="filter-select"
                  name="sector"
                  aria-label="Sektor auswählen"
                  value={formData.sector || 'All'}
                  onChange={onInputChange}
                >
                  {SECTOR_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          </div>

          <div className="filter-modal-section">
            <button
              type="button"
              className="filter-section-header"
              onClick={() => onToggleSection('valuation')}
              aria-expanded={!collapsedSections.valuation}
              aria-controls="filter-section-valuation"
            >
              <span>Bewertungskennzahlen</span>
              <i className={`fas fa-chevron-${collapsedSections.valuation ? 'down' : 'up'}`} aria-hidden="true"></i>
            </button>
            {!collapsedSections.valuation && (
              <div id="filter-section-valuation" className="filter-sliders-container">
                {VALUATION_SLIDERS.map(renderSlider)}
              </div>
            )}
          </div>

          <div className="filter-modal-section">
            <button
              type="button"
              className="filter-section-header"
              onClick={() => onToggleSection('income')}
              aria-expanded={!collapsedSections.income}
              aria-controls="filter-section-income"
            >
              <span>Dividenden & Profitabilität</span>
              <i className={`fas fa-chevron-${collapsedSections.income ? 'down' : 'up'}`} aria-hidden="true"></i>
            </button>
            {!collapsedSections.income && (
              <div id="filter-section-income" className="filter-sliders-container">
                {INCOME_SLIDERS.map(renderSlider)}
              </div>
            )}
          </div>

          <div className="filter-modal-section">
            <button
              type="button"
              className="filter-section-header"
              onClick={() => onToggleSection('growth')}
              aria-expanded={!collapsedSections.growth}
              aria-controls="filter-section-growth"
            >
              <span>Wachstumskennzahlen</span>
              <i className={`fas fa-chevron-${collapsedSections.growth ? 'down' : 'up'}`} aria-hidden="true"></i>
            </button>
            {!collapsedSections.growth && (
              <div id="filter-section-growth" className="filter-sliders-container">
                {GROWTH_SLIDERS.map(renderSlider)}
              </div>
            )}
          </div>
        </div>

        <div className="filter-modal-footer">
          <button type="button" className="filter-reset-btn" onClick={onReset}>
            Zurücksetzen
          </button>
          <button type="button" className="filter-apply-btn" onClick={onApply} disabled={loading}>
            {loading && <span className="btn-spinner"></span>}
            Ergebnisse anzeigen
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterSheet;
